var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_4719)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_82_4719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7Z",
    fill: "#10D173"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45422 4.08301V5.26747H7.64968V6.04184C9.11093 6.10834 10.2096 6.39417 10.2096 6.73717C10.2096 7.07988 9.11093 7.36572 7.64968 7.43222V9.91634H6.3643V7.4328C4.89693 7.36717 3.79297 7.08076 3.79297 6.73717C3.79297 6.3933 4.89751 6.10688 6.3643 6.04155V5.26717H4.55976V4.08301H9.45422ZM7.64968 7.13559C8.80293 7.08309 9.65693 6.89322 9.65693 6.66717C9.65693 6.44113 8.80293 6.25126 7.64851 6.19876V6.91451C7.22025 6.93691 6.79112 6.9371 6.36284 6.91509V6.19672C5.20405 6.24922 4.34451 6.4388 4.34451 6.66601C4.34451 6.89322 5.20405 7.08338 6.36284 7.13559L6.43926 7.13851H6.44043C6.51714 7.14142 6.59501 7.14405 6.67376 7.1458H6.68134L6.74784 7.14697H6.76739L6.82309 7.14784H7.18009L7.23668 7.14697H7.25709L7.32826 7.14551H7.33176C7.38484 7.14434 7.43764 7.14288 7.48926 7.14113H7.49714L7.56714 7.13851H7.5753L7.64968 7.13559Z",
    fill: "#141414"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_4719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_82_4719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.976d8119b81acbf19c2c8517d3240ec8.svg";
export { ForwardRef as ReactComponent };